import { ViewModel, View, ObservableArray } from "binder"
import { ReplacementReasonManipulationView } from "./replacementReasonManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ReplacementReasonEditorViewModel, ReplacementReasonInserter, ReplacementReasonUpdater } from "./ReplacementReasonEditor/replacementReasonEditor-viewModel";
import { IReplacementReason } from "./IReplacementReason";

export class ReplacementReasonManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف علت تعویض';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.replacementReasons = ObservableArray.create<ReplacementReason>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new ReplacementReasonManipulationView();
    }
    public getTypeId(): string {
        return "VM-5FD21D7F-AB25-4243-A993-4FFD21010F8C"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set replacementReasons(v: ObservableArray<ReplacementReason>) { this._replacementReasons = v; } public get replacementReasons(): ObservableArray<ReplacementReason> { return this._replacementReasons; } private _replacementReasons: ObservableArray<ReplacementReason>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ReplacementReasonServices/ListAllReplacementReasons', {
                FilteringInformation: filteringInformation
            });
            this.replacementReasons.update(...result.ReplacementReasons.map((x, i) => {
                let r = new ReplacementReason(this);
                r.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                r.id = x.Id;
                r.reasonText = x.Description;
                r.code = x.Code;
                r.toolTypeId = x.ToolTypeId;
                r.toolTypeName = x.ToolTypeName;
                r.toolTypeCode = x.ToolTypeCode;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ReplacementReasonEditorViewModel(this, new ReplacementReasonInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(replacementReason: IReplacementReason) {
        let popup = new ReplacementReasonEditorViewModel(this, new ReplacementReasonUpdater());
        await replacementReason.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(replacementReason: ReplacementReason): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/ReplacementReasonServices/DeleteReplacementReason", {
                    ReplacementReasonId: replacementReason.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class ReplacementReason extends ViewModel implements IReplacementReason {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ReplacementReasonManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ReplacementReasonManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set reasonText(v: string) { this._reasonText = v; } public get reasonText(): string { return this._reasonText; } private _reasonText: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeName(v: string) { this._toolTypeName = v; } public get toolTypeName(): string { return this._toolTypeName; } private _toolTypeName: string;
    public set toolTypeCode(v: string) { this._toolTypeCode = v; } public get toolTypeCode(): string { return this._toolTypeCode; } private _toolTypeCode: string;

    setToolTypeId(id: string) {
        this.toolTypeId = id;
    }
    getToolTypeId(): string {
        return this.toolTypeId;
    }

    async cloneTo(replacementReason: IReplacementReason) {
        replacementReason.id = this.id;
        replacementReason.reasonText = this.reasonText;
        replacementReason.code = this.code;
        replacementReason.setToolTypeId(this.toolTypeId);
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
